import Button from "@mui/material/Button";
import { gapi } from "gapi-script";
import React, { useEffect, useState } from "react";
import { GoogleLogin } from "react-google-login";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import Loading from "../../../Ui/Loading/Loading";
import "./login.css";
import { Logger } from "../../../Logger/Logger";
import { Box, Fade, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
const style = {
  position: "absolute",
  // top: "50%",
  // left: "50%",
  bottom: "2%",
  right: "2%",
  // transform: "translate(-50%, -50%)",
  width: 350,
  // height: 150,
  // border: 0,
  // bgcolor: "#CDDCD1",
  bgcolor: "#faebd7",
  opacity: "0.7",
  borderRadius: 6,
  // boxShadow: 24,
  p: 2,
  outline: "none"
};

// const client_id =
//   "662915365340-ru45m3omcd4ap3elqoel9svluirock3m.apps.googleusercontent.com";
const client_id = "469012308334-li4jlkc3da02go9f7uafnvc3b62khi9d.apps.googleusercontent.com"

const Login = ({ setIsLoggedIn }) => {
  const navigator = useNavigate();
  const cookies = new Cookies();
  const [loading, setLoading] = useState(false);
  const currentDate = new Date().getFullYear();
  const [cookieState, setCookieState] = useState(false)
  const [open, setOpen] = useState(true);

  useEffect(() => {
    // if (window.navigator.cookieEnabled) {
    //   Logger.debug("Cookies are Enabled", window.navigator.cookieEnabled)
    //   setCookieState(false)
    // }
    // else {
    //   Logger.debug("Cookies are disabled", window.navigator.cookieEnabled)
    //   setCookieState(true)
    // }


    function start() {
      gapi.client.init({
        clientId: client_id,
        scope: "",
      });
    }
    gapi.load("client:auth2", start);
  },[cookieState]);

  const onFailureSuccessBtn = (response) => {
    Logger.debug("onFailureBtn", response.error);
    if (response.error == "idpiframe_initialization_failed" || response.error == "popup_closed_by_user") {
      Logger.debug("Cookies are disabled", window.navigator.cookieEnabled)
      setCookieState(true)
      setOpen(true)
    }
    else {
      Logger.debug("Cookies are Enabled", window.navigator.cookieEnabled)
      setCookieState(false)
      setOpen(false)
    }

  };

  const onSuccessLogin = (res) => {
    Logger.debug("Login Success:", res);

    cookies.set("UserLogin", res.tokenId);
    cookies.set("UserLoginAccessToken", res.accessToken);
    cookies.set("createdBy", res.wt.cu);
    cookies.set("UserName", res.wt.Ad);
    setLoading(true);
    setIsLoggedIn(true);
    setTimeout(() => {
      navigator("/secured/empDashboard");
    }, 1000);
  };

  const handleClick = () => {
    setCookieState(false);
  }

  return (
    <>
      {!loading ? (
        <div>
          <img
            draggable="false"
            src="Images/background-01.jpg"
            alt="login"
            style={{ height: "100vh", width: "100%", objectFit: "cover" }}
          />
          <div className="container w-[100%]">

            <div className="centered flex flex-col justify-center items-center">
              <img
                draggable="false"
                className=""
                src="Images/logo-01.svg"
                alt="wishtree_logo"
                style={{ height: "60px", width: "100%" }}
              />
              <h1 className="logotextHeading_1">Wishtree Helpdesk</h1>

              <GoogleLogin
                icon={false}
                clientId={client_id}
                buttonText="Login with Google"
                onSuccess={onSuccessLogin}
                onFailure={onFailureSuccessBtn}
                cookiePolicy={"single_host_origin"}
                isSignedIn={false}
                className="loginBtn"
              />
              <div className="copyright-footer">
                <p>
                  {" "}
                  &copy; {currentDate},
                  <a href="https://www.wishtreetech.com/" target="_blank" className="text-[#F05E67] underline">Wishtree Technologies.</a>
                  All Rights Reserved.
                </p>
              </div>
              {cookieState &&
                <>
                  <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={open}
                  >
                    {/* <Fade in={open}> */}
                    <Box sx={style}>
                      <div className="flex justify-between">
                        <h1 className="mb-[15px] text-xl">
                          Allow Cookies
                        </h1>
                        <div>
                          <CloseIcon className="cursor-pointer" onClick={() => setOpen(false)} />
                        </div>
                      </div>
                      <p className="text-[14px]">Your browser has cookies disabled. Make sure your cookies are enabled and try again.</p>
                    </Box>
                    {/* </Fade> */}
                  </Modal>
                </>
              }
            </div>

          </div>

          {/* {cookieState && <Button>Allow Cookies</Button>} */}
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
};
export default Login;
